// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OrderStatusSkeleton-orderStatusSkeletonBox-x_VB8 {
    padding: 24px;
    background: var(--background-primary);
    margin-top: 6px;
    border-radius: 0 0 var(--radius-3) var(--radius-3);
}

.OrderStatusSkeleton-orderStatusSkeletonTitle-wPZ9j {
    max-width: 120px;
    height: 30px;
    background: var(--skeleton-secondary-bg);
    border-radius: var(--radius-5);
    margin-bottom: 12px;
}

.OrderStatusSkeleton-orderStatusSkeletonTrackBox-sLB4U {
    display: grid;
    grid-template-columns: 28px 1fr;
    gap: 12px;
    grid-gap: 12px;
    padding-bottom: 24px;
    position: relative;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    isolation: isolate;
}

.OrderStatusSkeleton-orderStatusSkeletonTrackBox-sLB4U:last-child::after {
    display: none;
}

.OrderStatusSkeleton-orderStatusSkeletonTrackBox-sLB4U:last-child {
    padding-bottom: 0;
}

.OrderStatusSkeleton-orderStatusSkeletonTrackBox-sLB4U::after {
    content: '';
    position: absolute;
    top: 14px;
    left: 14px;
    border-left: 1px dashed var(--primary-border);
    height: calc(100% - 14px);
    z-index: -1;
}

.OrderStatusSkeleton-orderStatusSkeletonTrackImg-d68aB {
    position: relative;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    z-index: 1;
    background: var(--skeleton-secondary-bg);
}

.OrderStatusSkeleton-orderStatusSkeletonTrackContent-lISzd {
    height: 26px;
    background: var(--skeleton-secondary-bg);
    border-radius: var(--radius-5);
}

.OrderStatusSkeleton-orderStatusSkeletonTrackContent1-bDiRU {
    max-width: 123px;
}

.OrderStatusSkeleton-orderStatusSkeletonTrackContent2-UJVmn,
.OrderStatusSkeleton-orderStatusSkeletonTrackContent4-CGeYU {
    max-width: 134px;
}

.OrderStatusSkeleton-orderStatusSkeletonTrackContent3-PUJyg {
    max-width: 83px;
}

.OrderStatusSkeleton-orderStatusSkeletonTrackContent5-PRt8t {
    max-width: 113px;
}

.OrderStatusSkeleton-orderStatusSkeletonTrackContent6-bBHEC {
    max-width: 107px;
}

@media (max-width: 767px) {
    .OrderStatusSkeleton-orderStatusSkeletonBox-x_VB8 {
        padding: 18px;
    }

    .OrderStatusSkeleton-orderStatusSkeletonTitle-wPZ9j {
        height: 28px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Skeleton/ViewBooking/OrderStatusSkeleton/OrderStatusSkeleton.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,qCAAqC;IACrC,eAAe;IACf,kDAAkD;AACtD;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,wCAAwC;IACxC,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,+BAA+B;IAC/B,SAAS;IACT,cAAc;IACd,oBAAoB;IACpB,kBAAkB;IAClB,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,6CAA6C;IAC7C,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,wCAAwC;AAC5C;;AAEA;IACI,YAAY;IACZ,wCAAwC;IACxC,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,YAAY;IAChB;AACJ","sourcesContent":[".orderStatusSkeletonBox {\n    padding: 24px;\n    background: var(--background-primary);\n    margin-top: 6px;\n    border-radius: 0 0 var(--radius-3) var(--radius-3);\n}\n\n.orderStatusSkeletonTitle {\n    max-width: 120px;\n    height: 30px;\n    background: var(--skeleton-secondary-bg);\n    border-radius: var(--radius-5);\n    margin-bottom: 12px;\n}\n\n.orderStatusSkeletonTrackBox {\n    display: grid;\n    grid-template-columns: 28px 1fr;\n    gap: 12px;\n    grid-gap: 12px;\n    padding-bottom: 24px;\n    position: relative;\n    align-items: center;\n    isolation: isolate;\n}\n\n.orderStatusSkeletonTrackBox:last-child::after {\n    display: none;\n}\n\n.orderStatusSkeletonTrackBox:last-child {\n    padding-bottom: 0;\n}\n\n.orderStatusSkeletonTrackBox::after {\n    content: '';\n    position: absolute;\n    top: 14px;\n    left: 14px;\n    border-left: 1px dashed var(--primary-border);\n    height: calc(100% - 14px);\n    z-index: -1;\n}\n\n.orderStatusSkeletonTrackImg {\n    position: relative;\n    width: 28px;\n    height: 28px;\n    border-radius: 50%;\n    z-index: 1;\n    background: var(--skeleton-secondary-bg);\n}\n\n.orderStatusSkeletonTrackContent {\n    height: 26px;\n    background: var(--skeleton-secondary-bg);\n    border-radius: var(--radius-5);\n}\n\n.orderStatusSkeletonTrackContent1 {\n    max-width: 123px;\n}\n\n.orderStatusSkeletonTrackContent2,\n.orderStatusSkeletonTrackContent4 {\n    max-width: 134px;\n}\n\n.orderStatusSkeletonTrackContent3 {\n    max-width: 83px;\n}\n\n.orderStatusSkeletonTrackContent5 {\n    max-width: 113px;\n}\n\n.orderStatusSkeletonTrackContent6 {\n    max-width: 107px;\n}\n\n@media (max-width: 767px) {\n    .orderStatusSkeletonBox {\n        padding: 18px;\n    }\n\n    .orderStatusSkeletonTitle {\n        height: 28px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"orderStatusSkeletonBox": `OrderStatusSkeleton-orderStatusSkeletonBox-x_VB8`,
	"orderStatusSkeletonTitle": `OrderStatusSkeleton-orderStatusSkeletonTitle-wPZ9j`,
	"orderStatusSkeletonTrackBox": `OrderStatusSkeleton-orderStatusSkeletonTrackBox-sLB4U`,
	"orderStatusSkeletonTrackImg": `OrderStatusSkeleton-orderStatusSkeletonTrackImg-d68aB`,
	"orderStatusSkeletonTrackContent": `OrderStatusSkeleton-orderStatusSkeletonTrackContent-lISzd`,
	"orderStatusSkeletonTrackContent1": `OrderStatusSkeleton-orderStatusSkeletonTrackContent1-bDiRU`,
	"orderStatusSkeletonTrackContent2": `OrderStatusSkeleton-orderStatusSkeletonTrackContent2-UJVmn`,
	"orderStatusSkeletonTrackContent4": `OrderStatusSkeleton-orderStatusSkeletonTrackContent4-CGeYU`,
	"orderStatusSkeletonTrackContent3": `OrderStatusSkeleton-orderStatusSkeletonTrackContent3-PUJyg`,
	"orderStatusSkeletonTrackContent5": `OrderStatusSkeleton-orderStatusSkeletonTrackContent5-PRt8t`,
	"orderStatusSkeletonTrackContent6": `OrderStatusSkeleton-orderStatusSkeletonTrackContent6-bBHEC`
};
module.exports = ___CSS_LOADER_EXPORT___;
